import { render, staticRenderFns } from "./bidOrderDetail.vue?vue&type=template&id=35cb9a6c&scoped=true"
import script from "./bidOrderDetail.vue?vue&type=script&lang=js"
export * from "./bidOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./bidOrderDetail.vue?vue&type=style&index=0&id=35cb9a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb9a6c",
  null
  
)

export default component.exports